import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";

/**
 * A performance driven directive that does the following:
 * * will not render the html it is placed on until the kb-if evaluates to truthy (like ng-if)
 * * will NOT destroy the html when kb-if thereafter evaluates to false.  Instead, it will
 *   hide the html like ng-show would, but also suspend all the watchers on this element and any children.
 * 
 * Uses the feature described here:  https://github.com/angular/angular.js/pull/16308
 */
@NgComponent({
    token: Token.KbIf,
    dependencies: [
        Token.$Animate
    ]
})
export class KbIf extends Directive {
    constructor(
        $animate: ng.animate.IAnimateService
    ) {
        super();
        this.watchAtt = "kbIf";
        this.restrict = "A";
        this.priority = 600;
        this.transclude = "element";
        this.terminal = true;
        this.$$tlb = true;
        this.link = (scope, element: JQuery, atts, ctrl, $transclude) => {
            let innerScope;
            let innerElement;           

            let hide = () => {
                $animate.addClass(innerElement, "ng-hide", {
                    tempClasses: "ng-hide-animate"
                } as any);
            };
            let show = () => {
                $animate.removeClass(innerElement, "ng-hide", {
                    tempClasses: "ng-hide-animate"
                } as any);
            };
            scope.$watch(atts[this.watchAtt], (value, oVal) => {

                // $animate[value ? 'removeClass' : 'addClass'](innerElement, NG_HIDE_CLASS, {
                //     tempClasses: NG_HIDE_IN_PROGRESS_CLASS
                // });

                if (value) {
                    if (!innerElement) {
                        // Add the transcluded content after the transclusion comment placeholder    
                        $transclude((el, sc) => {
                            element.after(el);
                            innerElement = el;
                            innerScope = sc;
                            innerScope.$resume();
                            $animate.enter(el, element.parent(), element);
                            innerElement.removeClass("ng-hide");
                        });
                    } else {
                        innerScope.$resume();
                        show();
                    }       
                } else {
                    if (innerElement) {
                        if (this.hideDelay) {
                            setTimeout(() => {
                                hide();
                            }, this.hideDelay)
                        } else {
                            hide();
                        }    
                        // Before suspending, the scope should digest one more time to allow updates (e.g. initial watch)
                        (scope as any).$$postDigest(() => {
                            innerScope.$suspend();
                        });
                    }    
                }
            });
        };
    }

    public hideDelay: number;
    public watchAtt: string;
}

